{
    "data": {
        "AppComponentVersionsMap": {
            "type": "object",
            "properties": {
                "overrideId": {
                    "type": "string"
                },
                "components": {
                    "type": "object",
                    "additionalProperties": {
                        "type": "object",
                        "properties": {
                            "version": {
                                "type": "string"
                            }
                        },
                        "required": ["version"],
                        "additionalProperties": false
                    }
                }
            },
            "required": ["overrideId", "components"],
            "isTopLevelDataNode": true,
            "additionalProperties": false
        }
    }
}
